import React from 'react';
import {
  Box,
  Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import QuillEditor from 'src/components/QuillEditor';
import UserCell from 'src/components/cells/UserCell';
import SlateRichTextArea from '../../../components/slate/SlateRichTextArea';


const PreviewEmail = ({
  subject,
  recipients,
  ccs,
  bccs,
  body
}: any) => (
  <Paper>
    <Box p={2} display="flex" alignItems="center">
      <Box pr={2}>
        <Typography variant="h5">
          To:
        </Typography>
      </Box>
      <UserCell accounts={recipients} />
    </Box>
    <Divider />
    {
        ccs.length ? (
          <>
            <Box p={2} display="flex" alignItems="center">
              <Box pr={1}>
                <Typography variant="h5">
                  Cc:
                </Typography>
              </Box>
              <UserCell accounts={ccs} />
            </Box>
            <Divider />
          </>
        ) : null
      }
    {
        bccs.length ? (
          <>
            <Box p={2} display="flex" alignItems="center">
              <Box pr={1}>
                <Typography variant="h5">
                  Bcc:
                </Typography>
              </Box>
              <UserCell accounts={bccs} />
            </Box>
            <Divider />
          </>
        ) : null
      }
    <Box p={2} display="flex" alignItems="center">
      <Box pr={1}>
        <Typography variant="h5">
          Subject:
        </Typography>
      </Box>
      <Typography>
        {subject}
      </Typography>
    </Box>
    <Divider />
    <SlateRichTextArea
      value={body}
      readOnly
    />
  </Paper>
);

export default PreviewEmail;
